var _path, _path2, _path3, _path4, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_29_154)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33057 46.9852H70.6694",
    stroke: "#2FC77E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1222 22.6054L9.55713 33.4462H13.7227V46.9851H22.5217V33.4462H26.6874L18.1222 22.6054Z",
    stroke: "#2FC77E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9933 11.1479L30.4282 21.9886H34.5937V46.9851H43.3928V21.9886H47.5585L38.9933 11.1479Z",
    stroke: "#2FC77E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_29_154",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 78,
    height: 78
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9998 77V1.00022H1V77H76.9998Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_29_154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.8678 40.3V12.3646H69.0332L60.4683 1.52366L51.9031 12.3646H56.0686V46.9853H64.8678L64.8529 35.9337",
    stroke: "#2FC77E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6241 59.4629L63.0085 63.9992C62.0199 65.7115 60.0061 66.5523 58.0898 66.0587L55.3692 65.3518C54.4719 65.1204 53.5139 65.3 52.7704 65.8546C51.3257 66.9274 49.7628 67.8311 48.1122 68.5479C47.2635 68.9165 46.6314 69.6539 46.3846 70.5449L45.6383 73.2487C45.1082 75.1561 43.3731 76.4767 41.3959 76.4767H36.1603C34.18 76.4767 32.4434 75.1561 31.9178 73.2487L31.1684 70.5449C30.9216 69.6539 30.2896 68.9165 29.4409 68.5479C27.7899 67.8318 26.2269 66.9281 24.7827 65.8546C24.0377 65.3 23.0796 65.1204 22.1825 65.3518L19.4603 66.0587C17.5454 66.5523 15.5362 65.7115 14.5461 63.9992L11.9275 59.4629C10.9359 57.7507 11.2131 55.5877 12.6039 54.177L14.572 52.1738C15.2208 51.5127 15.5423 50.5957 15.4372 49.6772C15.3366 48.7937 15.2848 47.8964 15.2848 46.9855H28.562C28.562 52.6263 33.1349 57.1993 38.7759 57.1993C44.4165 57.1993 48.9911 52.6263 48.9911 46.9855H62.2667C62.2667 47.8948 62.2149 48.7937 62.1144 49.6756C62.0091 50.5942 62.3322 51.5127 62.9797 52.1723L64.9522 54.177C66.3384 55.5877 66.6142 57.7507 65.6241 59.4629Z",
    stroke: "#2FC77E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_29_154"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 78,
    height: 78,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.9f0c4245f46d67a22ab143b46ab8d645.svg";
export { ForwardRef as ReactComponent };